import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Bar } from 'react-chartjs';

import PathwaySelect from '../Components/PathwaySelect';

import { getProgress } from '../../../Actions/Dashboard/progress';

const chartOptions = {
  responsive: true,
  barStrokeWidth: 1,
  animation: false,
};

class YourProgress extends React.Component {
  state = {
    chartData: {
      labels: ['User time by day'],
      datasets: [],
    },
  };

  componentDidMount() {
    this.props.dispatch(getProgress(this.props.pathway));
  }

  componentDidUpdate(prevProps) {
    if (this.props.pathway !== prevProps.pathway) {
      this.props.dispatch(getProgress(this.props.pathway));
    }

    if (JSON.stringify(this.props.dataset) !== JSON.stringify(this.state.chartData.datasets[0])) {
      const { chartData } = this.state;

      let fill = 'rgba(0,0,0,0.2)';
      let stroke = 'rgba(0,0,0,0.8)';
      let highlightFill = 'rgba(0,0,0,0.2)';
      let highlightStroke = 'rgba(0,0,0,0.8)';

      switch (this.props.pathway) {
        case 'weight':
          fill = 'rgba(251,232,250,1)';
          stroke = 'rgba(108,26,113,1)';
          highlightFill = 'rgba(255,150,132,0.2)';
          highlightStroke = 'rgba(255,99,131,0.8)';
          break;
        case 'activity':
          fill = 'rgba(222,247,249,1)';
          stroke = 'rgba(0,172,180,1)';
          highlightFill = 'rgba(255,150,132,0.2)';
          highlightStroke = 'rgba(255,99,131,0.8)';
          break;
        case 'smoking':
          fill = 'rgba(249,224,224,0.2)';
          stroke = 'rgba(2044,40,39,0.8)';
          highlightFill = 'rgba(255,150,132,0.2)';
          highlightStroke = 'rgba(255,99,131,0.8)';
          break;
        case 'alcohol':
          fill = 'rgba(255,248,232,0.2)';
          stroke = 'rgba(250,180,7,0.8)';
          highlightFill = 'rgba(255,150,132,0.2)';
          highlightStroke = 'rgba(255,99,131,0.8)';
          break;
        default:
          break;
      }
      const d = this.props.dataset;
      d.fillColor = fill;
      d.strokeColor = stroke;
      d.highlightFill = highlightFill;
      d.highlightStroke = highlightStroke;

      chartData.labels = this.props.labels;
      chartData.datasets = [d];

      this.setState({ chartData }); // eslint-disable-line
    }
  }

  render() {
    let previous = '';
    let now = '';
    let improvement = 0;
    let units = '';
    switch (this.props.pathway) {
      case 'activity':
        previous = 'How active you were when you joined us';
        now = 'How active you are now';
        improvement = this.props.last - this.props.first;
        units = 'days';
        break;
      case 'weight':
        previous = 'How much you weighed when you joined us';
        now = 'How much you weigh now';
        improvement = this.props.last - this.props.first;
        units = 'kg';
        break;
      case 'smoking':
        previous = 'How many cigarettes a day you smoked when you joined us';
        now = 'How many cigarettes a day you smoke are now';
        improvement = this.props.last - this.props.first;
        units = '';
        break;
      case 'alcohol':
        previous = 'How much you drank when you joined us';
        now = 'How much you are now';
        improvement = this.props.last - this.props.first;
        units = 'units';
        break;
      default:
    }
    return (
      <div className="progress">
        <div className="col">
          <div className="pathwayRow">
            <PathwaySelect />
          </div>
          {this.state.chartData.datasets.length ? <Bar data={this.state.chartData} options={chartOptions} width="530" height="300" redraw /> : null}
        </div>
        <div className="col">
          <div className="row">
            <div className="col">
              <label>{previous}</label>
              <p className="result">{this.props.first} <span>{units}</span></p> 
            </div>
            <div className="col">
              <label>{now}</label>
              <p className="result">{this.props.last} <span>{units}</span></p> 
            </div>
            <div className="col">
              <label>Your improvement</label>
              <p className="result">{improvement} <span>{units}</span></p>
            </div>
          </div>
          <hr />
          <p>
            {this.props.message} {this.props.benchmark}.
          </p>
          <a href={this.props.progress} target="_blank" className="button">
            Update your progress
          </a>
        </div>
      </div>
    );
  }
}

YourProgress.propTypes = {
  dispatch: PropTypes.func.isRequired,
  dataset: PropTypes.object,
  labels: PropTypes.array,
  average: PropTypes.string,
  improvement: PropTypes.number,
  first: PropTypes.string,
  last: PropTypes.string,
  message: PropTypes.string,
  progress: PropTypes.string,
  benchmark: PropTypes.string,
  pathway: PropTypes.string.isRequired,
};

YourProgress.defaultProps = {
  dataset: {},
  labels: [],
  average: '',
  improvement: null,
  message: '',
  benchmark: '',
  progress: '',
  first: '',
  last: '',
};

export default connect(
  state => ({
    dataset: state.progress && state.progress.dataset ? state.progress.dataset : {},
    labels: state.progress && state.progress.labels ? state.progress.labels : [],
    average: state.progress ? state.progress.average : '',
    improvement: state.progress ? state.progress.improvement : '',
    message: state.progress ? state.progress.message : '',
    progress: state.progress ? state.progress.progress : '',
    benchmark: state.progress ? state.progress.benchmark : '',
    first: state.progress ? state.progress.first : '',
    last: state.progress ? state.progress.last : '',
    pathway: state.pathway,
  }),
  dispatch => ({ dispatch }),
)(YourProgress);



// WEBPACK FOOTER //
// ./src/Components/Dashboard/Modules/YourProgress.jsx